import { Box, Skeleton, Stack, Typography, Button } from '@mui/material';
import { useAuthentication } from '@/common-hooks/use-authentication';
import { Navigate, useLocation } from 'react-router-dom';

export default function Login() {
  const { isAuthenticated, loading, login } = useAuthentication();
  const location = useLocation();
  const from = (location.state as { from?: { pathname?: string; search?: string; hash?: string } } | undefined)?.from;
  const redirectTo = from ? `${from.pathname ?? ''}${from.search ?? ''}${from.hash ?? ''}` : '/';

  // If already authenticated, redirect to the original destination (if available).
  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Show login UI - matching ignite-frontend theme
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F6F6F6',
        p: 3,
      }}
    >
      <Box 
        sx={{ 
          width: '100%', 
          maxWidth: 400, 
          bgcolor: '#fff', 
          borderRadius: 1, 
          p: 4, 
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        }}
      >
        <Stack spacing={3}>
          <Typography variant="h4" sx={{ fontWeight: 600, textAlign: 'center', color: 'primary.main' }}>
            BCP Wizard Operations Portal
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center', color: 'text.secondary' }}>
            Sign in to access the dashboard
          </Typography>
          
          {loading ? (
            <Stack spacing={2}>
              <Skeleton variant="rectangular" height={48} />
              <Skeleton variant="rectangular" height={48} />
            </Stack>
          ) : (
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={() => login(redirectTo)}
              sx={{
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                bgcolor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.dark',
                },
              }}
            >
              Sign in with Okta
            </Button>
          )}
        </Stack>
      </Box>
    </Box>
  );
}
